<template>
  <router-view />
</template>


<script>
export default {
  name: "ticketmanagement",
};
</script>